import styled from "styled-components"
import { formatPriceByLocale } from "utils/utils"

export default function ModalHeader({ type, totalPrice, lowestPrice, lowestChallengePrice }) {
  return type === "normal" ? (
    <>
      <HeaderTitleTop isOrange>인증 없이</HeaderTitleTop>
      <HeaderTitleBottom>
        {`${formatPriceByLocale("ko", totalPrice ? totalPrice : lowestPrice)}원에 구매해요`}
      </HeaderTitleBottom>
    </>
  ) : (
    <>
      <HeaderTitleTop>
        {`${formatPriceByLocale("ko", totalPrice ? totalPrice : lowestPrice)}원에 사고`}
      </HeaderTitleTop>
      <HeaderTitleBottom>
        {`성공 시 `}
        <RefundPrice>{`${formatPriceByLocale(
          "ko",
          totalPrice ? totalPrice - lowestChallengePrice : lowestChallengePrice
        )}원`}</RefundPrice>
        {` 환급 받아요`}
      </HeaderTitleBottom>
    </>
  )
}

const HeaderTitleTop = styled.h3`
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (22 / 375));
  color: ${({ isOrange }) => (isOrange ? "#FF6B00" : "#121212")};
  margin-bottom: calc(100vw * (7 / 375));
`

const HeaderTitleBottom = styled.h2`
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (24 / 375));
  color: #121212;
`

const RefundPrice = styled.p`
  display: inline-block;
  color: #ff6b00;
`
